// API Endpoint
const API = "https://api.pokemontcg.io/v2";
let products = JSON.parse(sessionStorage.getItem("collectionProducts"));
sessionStorage.removeItem("collectionProducts");

// --- Selecting DOM Elements --- //
const searchForm = document.querySelector(".search__box-form");
const searchInput = searchForm.querySelector("input");
const contentContainer = document.querySelector(".page__content");
// const allSetsBtn = document.querySelector(".search__sets");
const searchByArtistBtn = document.querySelector(".search__artist");
const searchByCardBtn = document.querySelector(".search__card");
const advancedBtn = document.querySelector(".search__advanced");
const closeAdvancedSearchBtn = document.querySelector(".close-advanced-search");
const advancedSearchContainer = document.querySelector(
  ".search__options--advanced"
).parentElement;
const optionsContainer = document.querySelector(".search__options--advanced");
const allOptions = [
  ...optionsContainer.querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("input"));
const allOptionsLabel = [
  ...optionsContainer.querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("label"));
const energyTypeOptions = [
  ...optionsContainer
    .querySelector(".energy-type")
    .querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("input"));
const attacksTypeOptions = [
  ...optionsContainer
    .querySelector(".attacks-type")
    .querySelectorAll(".search__advanced-option"),
].map((option) => option.querySelector("input"));
const energyTypeOptionsLabel = energyTypeOptions.map(
  (option) => option.nextElementSibling
);
const attacksTypeOptionsLabel = attacksTypeOptions.map(
  (option) => option.nextElementSibling
);
const btnScrollUp = document.querySelector(".button-scroll-up");

// Default search is by card -- initial value
sessionStorage.setItem("search type", "card");

// --- Functions --- //
const cleanUI = function () {
  contentContainer.innerHTML = "";
};

const toggleScrollUpBtn = function () {
  const scrollPosition =
    document.documentElement.scrollTop > 1000 || document.body.scrollTop > 1000;

  if (
    contentContainer.querySelector(".cards").offsetWidth > 1000 &&
    scrollPosition
  ) {
    btnScrollUp.classList.remove("button-scroll-up--hidden");
  } else {
    btnScrollUp.classList.add("button-scroll-up--hidden");
  }
};

const updateInput = function (type) {
  // Cleaning the UI and search value
  cleanUI();
  searchInput.value = "";

  // Change the search by card value
  sessionStorage.setItem("search type", type);

  // Change the input placeholder
  searchInput.placeholder = `Search for POKEMON: THE POKEMON CARDS ${
    type === "card" ? "" : "BY ARTIST NAME"
  }`;
};

const toggleSearchAdanvaced = function (mode) {
  // show mode
  if (mode === "show") {
    // 1. highlight the button by adding an active class
    advancedBtn.classList.add("search__advanced-active");

    // 2. show the advanced search container
    advancedSearchContainer.classList.remove("hidden");
  } else {
    // hide mode
    // 1. highlight the button by adding an active class
    advancedBtn.classList.remove("search__advanced-active");

    // 2. show the advanced search container
    advancedSearchContainer.classList.add("hidden");
  }
};

const unselectAllAdvancedSearchFilters = function () {
  allOptions.forEach((option, i) => {
    option.checked = false;
    const currentOptionLabel = allOptionsLabel.at(i);

    currentOptionLabel.classList.remove("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.add("hidden");
  });
};

const toggleSearchOption = function (mode, index) {
  const currentOptionLabel = allOptionsLabel.at(index);

  if (mode === "active") {
    currentOptionLabel.classList.add("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.remove("hidden");
  } else {
    currentOptionLabel.classList.remove("advanced-option-active");
    currentOptionLabel
      .querySelector(".advanced-option-icon")
      .classList.add("hidden");
  }
};

const renderLoadingSpinner = function () {
  // Cleaning the UI
  cleanUI();

  const markup = `
    <div class="loading-spinner">
    </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

const renderRelatedProducts = function (cardName, artistName) {
  const markup = `
  <div class='page__content--related'>
    <div class="pokemon__related-products--btns-container search__options">
      <button class="pokemon__related-products--card" data-card="${cardName}">Show products related to this card</button>
      <!-- <button class="pokemon__related-products--artist" data-artist="${artistName}">Show products related to this artist</button> -->
    </div>

    <div class="cards pokemon__related-products--container"></div>
  </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);
};

const renderRelatedProductByCardName = function (cardName, artistName, search) {
  let filteredProductsByCardName;

  if (search) {
    const searchInputValue = searchInput.value
      .trim()
      .toLowerCase()
      .replaceAll("'", "’")
      .replaceAll(",", ",");
    filteredProductsByCardName = products
      .filter((product) => {
        // Create a new DOMParser
        const parser = new DOMParser();

        // Parse the HTML string
        const doc = parser.parseFromString(product.description, "text/html");

        // Get the text content
        const productDesc = doc.body.textContent;

        if (
          product.title.toLowerCase().includes(cardName.toLowerCase()) ||
          product.title.toLowerCase().includes(searchInputValue) ||
          productDesc.toLowerCase().includes(cardName.toLowerCase()) ||
          productDesc.toLowerCase().includes(searchInputValue)
        )
          return product;
      })
      .reverse();
  } else {
    filteredProductsByCardName = products
      .filter((product) =>
        product.title.toLowerCase().includes(cardName.toLowerCase())
      )
      .reverse();
  }

  if (!filteredProductsByCardName.length) {
    const markup = `
      <div class='page__content--related'>
        <div class="pokemon__related-products--btns-container search__options">
          <button class="pokemon__related-products--card" data-card="${cardName}">Hide products related to this card</button>
          <!-- <button class="pokemon__related-products--artist" data-artist="${artistName}">Show products related to this artist</button> -->
        </div>

        <div class="pokemon__related-products--container">
          <p style="text-align: center;">We're sorry, but we couldn't find any products associated with this card.</p>
        </div>
      </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  } else {
    const markup = `
    <div class='page__content--related'>
      <div class="pokemon__related-products--btns-container search__options">
        <button class="pokemon__related-products--card" data-card="${cardName}">Hide products related to this card</button>
        <!-- <button class="pokemon__related-products--artist" data-artist="${artistName}">Show products related to this artist</button> -->
      </div>

      <div class="pokemon__related-products--container">
        <ul class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8" role="list">
          ${filteredProductsByCardName
            .map(
              (product) => `
            <li>
              <div class="pokemon__related-product card card--product h-full card--product-contained relative flex">

                <!-- WHISHLIST -->

                <!-- MEDIA -->
                <div class="card__media ${
                  product.media.length > 1 ? "has-hover-image" : ""
                } relative">
                  <a href="/products/${product.handle}" aria-label="${
                product.title
              }" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
                    <img src="${
                      product.media?.at(0).src
                    }&width=460" loading="lazy" class="img-fit card__main-image" width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                    <img src="${
                      product.media?.at(1)?.src
                    }&width=460" loading="lazy" class="img-fit card__hover-image width="2400" height="1400" alt="${
                product.title
              } | Ultra PRO International" style="width: 100%;">
                  </a>
                </div>

                <!-- CONTENT -->
                <div class="card__info-container flex flex-col flex-auto relative">
                  <div class="card__info w-full">
                    <div class="card__info-inner inline-block w-full">
                      <p class="font-bold mb-1">
                        <a href="/products/${
                          product.handle
                        }" class="card-link text-current js-prod-link">${
                product.title
              }</a>
                      </p>

                      <!--
                      <div class="price">
                        <div class="price__default">
                          <strong class="price__current">€${new Intl.NumberFormat(
                            "fr-BE"
                          ).format(product.variants?.at(0).price)} EUR</strong>
                        </div>
                      </div>
                      -->
                    </div>
                  </div>

                  <!-- VIEW PRODUCT -->
                  <div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below">
                    <a class="btn btn--primary w-full" href="/products/${
                      product.handle
                    }">
                      <span class="quick-add-btn-text">View product</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          `
            )
            .join("")}
        </ul>
      </div>
    </div>
    `;

    contentContainer.querySelector(".page__content--related").innerHTML = "";
    contentContainer
      .querySelector(".page__content--related")
      .insertAdjacentHTML("beforeend", markup);
  }
};

// const renderRelatedProductByArtistName = function (cardName, artistName) {
//   const filteredProductsByArtistName = products.filter((product) =>
//     product.tags.toLowerCase().includes(`artist_${artistName.toLowerCase()}`)
//   );

//   if (!filteredProductsByArtistName.length) {
//     const markup = `
//       <div class='page__content--related'>
//         <div class="pokemon__related-products--btns-container search__options">
//           <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
//           <button class="magic__related-products--artist" data-artist="${artistName}">Hide products related to this artist</button>
//         </div>

//         <div class="magic__related-products--container">
//           <p style="text-align: center;">We're sorry, but we couldn't find any products associated with this artist.</p>
//         </div>
//       </div>
//     `;

//     contentContainer.querySelector(".page__content--related").innerHTML = "";
//     contentContainer
//       .querySelector(".page__content--related")
//       .insertAdjacentHTML("beforeend", markup);
//   } else {
//     const markup = `
//     <div class='page__content--related'>
//       <div class="magic__related-products--btns-container search__options">
//         <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
//         <button class="magic__related-products--artist" data-artist="${artistName}">Hide products related to this artist</button>
//       </div>

//       <div class="magic__related-products--container">
//         <ul class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8" role="list">
//           ${filteredProductsByArtistName
//             .map(
//               (product) => `
//             <li>
//               <div class="magic__related-product card card--product h-full card--product-contained relative flex">

//                 <!-- WHISHLIST -->

//                 <!-- MEDIA -->
//                 <div class="card__media ${
//                   product.images.length > 1 ? "has-hover-image" : ""
//                 } relative">
//                   <a href="/products/${product.handle}" aria-label="${
//                 product.title
//               }" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">
//                     <img src="${
//                       product.images?.at(0).src
//                     }&width=460" loading="lazy" class="img-fit card__main-image" width="2400" height="1400" alt="${
//                 product.title
//               } | Ultra PRO International" style="width: 100%;">
//                     <img src="${
//                       product.images?.at(1)?.src
//                     }&width=460" loading="lazy" class="img-fit card__hover-image width="2400" height="1400" alt="${
//                 product.title
//               } | Ultra PRO International" style="width: 100%;">
//                   </a>
//                 </div>

//                 <!-- CONTENT -->
//                 <div class="card__info-container flex flex-col flex-auto relative">
//                   <div class="card__info w-full">
//                     <div class="card__info-inner inline-block w-full">
//                       <p class="font-bold mb-1">
//                         <a href="/products/${
//                           product.handle
//                         }" class="card-link text-current js-prod-link">${
//                 product.title
//               }</a>
//                       </p>

//                       <!--
//                       <div class="price">
//                         <div class="price__default">
//                           <strong class="price__current">€${new Intl.NumberFormat(
//                             "fr-BE"
//                           ).format(product?.variants?.at(0).price)} EUR</strong>
//                         </div>
//                       </div>
//                       -->
//                     </div>
//                   </div>

//                   <!-- VIEW PRODUCT -->
//                   <div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below">
//                     <a class="btn btn--primary w-full" href="/products/${
//                       product.handle
//                     }">
//                       <span class="quick-add-btn-text">View product</span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </li>
//           `
//             )
//             .join("")}
//         </ul>
//       </div>
//     </div>
//     `;

//     contentContainer.querySelector(".page__content--related").innerHTML = "";
//     contentContainer
//       .querySelector(".page__content--related")
//       .insertAdjacentHTML("beforeend", markup);
//   }
// };

const renderCards = function (data, moreData = "") {
  const { data: cards, totalCount } = data;

  // Cleaning the UI
  cleanUI();

  let loadingMarkup = "";

  if (moreData === "fetching") {
    loadingMarkup = `
      <div style="margin-top: 1.6rem; display: flex; flex-direction: column; align-items: center;">
        <div class="loading-spinner" style="margin-bottom: 1rem;"></div>
        <p>Loading more cards...</p>
      </div>
    `;
  }

  const markup = `
    <p style="color: #ffffffe0; margin-bottom: 3rem; text-align: center;">
      Total cards: ${totalCount}
    </p>

    <div class='cards'>
      ${cards
        .map((card) =>
          card.images
            ? `<img class='cards__img' src='${card.images?.small}' alt='${card.name}' data-card-id='${card.id}' loading='lazy' />`
            : ""
        )
        .join("")}
    </div>

    ${loadingMarkup}
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);

  // Scroll UP button
  window.addEventListener("scroll", toggleScrollUpBtn);
};

const renderCard = function (card) {
  // Cleaning the UI
  cleanUI();

  const markup = `
      <p style="color: #ffffffe0; max-width: 100rem; margin-inline: auto; margin-bottom: 3rem; text-align: center;" class="pokemon-card__rotate-message">
        NOTE: 🔍 Unlock the secrets of each card! 🃏 Click on the "Flip it" button to reveal its hidden legalities and unleash your strategic prowess! 🌟 Click on the set box to uncover related cards or dive into the world of your favorite artist by clicking on their name. Happy discovering! ✨
      </p>
      <p style="color: #ffffffe0; margin-bottom: 3rem; text-align: center;" class="pokemon-card__message">
        NOTE: 🌟 Click on the set box to uncover related cards or dive into the world of your favorite artist by clicking on their name. Happy discovering! ✨
      </p>

      <div class="pokemon-card">
        <img
          src="${card.images?.large}"
          alt="${card.name}"
          loading="lazy"
        >

        <div class="pokemon-card__container--rotate">
          <div class="pokemon-card__prints pokemon-card__prints--rotate">
            <div class="pokemon-card__set">
              <div class="pokemon-card__set-series">
                <!-- Set series -->
                <p role="h4">
                  <span class="sub-title">&mdash; Release series</span>
                  ${card.set.series}
                </p>
                <!-- Set series image -->
                <img src="${card.set.images?.logo}" alt="${
    card.set.series
  } logo" loading="lazy" />
              </div>
              <div class='pokemon-card__set-info' data-set='${card.set.id}'>
                <!-- Set name (set) -->
                <p role="h4">
                  <span class="sub-title">&mdash; Release name</span>
                  ${card.set.name} ${
    card.set.ptcgoCode ? `(${card.set.ptcgoCode})` : ""
  }
                </p>
                <!-- #collection_number / rarity / lang / finishes -->
                <p>#${card.number} &middot; ${card.rarity} ${
    card.regulationMark ? `&middot; ${card.regulationMark}` : ""
  }</p>
              </div>
            </div>
            
            <div class="pokemon-card__info">
              <!-- Name -->
              <p role="h4">
                <span class="sub-title">&mdash; Card name</span>
                  ${card.name}
              </p>
              </p>
              <!-- Supertype -->
              <p role="h4">
                <span class="sub-title">&mdash; Card supertype</span>
                ${card.supertype}
              </p>
              <!-- Artist -->
              <p role="h4">
                <span class="sub-title">&mdash; Illustrated by</span>
                <span class="pokemon-card__link pokemon-card__artist">${
                  card.artist
                }</span>
              </p>

              ${
                card.hp
                  ? `<!-- HP -->
              <p role="h4">
                <span class="sub-title">&mdash; Card hp</span>
                <span class="pokemon-card__info--hp">
                  <span class="pokemon-card__info--hp-text">
                    <span>HP</span>
                    <span>${card.hp}</span>
                  </span>
                  ${
                    card.types
                      ? `<img class="pokemon-card__info--hp-symbol" src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${card.types
                          .at(0)
                          .toLowerCase()}.png?v=1718968515" alt="${card.types.at(
                          0
                        )} symbol" />`
                      : ""
                  }
                </span>
              </p>`
                  : ""
              }
              
              ${
                card.attacks
                  ? `<!-- Attacks -->
              <div class="pokemon-card__info--attacks ${
                card?.abilities ? "pokemon-card__border-btm" : ""
              }">
                <p class="sub-title last">&mdash; Card attacks</p>
                ${card.attacks
                  .map((attack) => {
                    return `
                    <div class="pokemon-card__info--attack">
                      <div class="pokemon-card__info--attack-title">
                        <p>${attack.name}</p>
                        <div>
                          <p>${attack.damage}</p>
                          ${attack.cost
                            .map((cost) => {
                              if (cost !== "Free")
                                return `
                                <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${cost.toLowerCase()}.png?v=1718968515" alt="${cost} symbol" />
                            `;
                            })
                            .join("")}
                        </div>
                      </div>
                      <p class="pokemon-card__info--attack-text">${
                        attack.text
                      }</p>
                    </div>
                  `;
                  })
                  .join("")}
              </div>`
                  : ""
              }
              ${
                card?.abilities
                  ? `<!-- Abilities -->
              <div class="pokemon-card__info--attacks">
                <p class="sub-title last">&mdash; Card abilities</p>
                ${card.abilities
                  .map((ability) => {
                    return `
                    <div class="pokemon-card__info--attack">
                      <div class="pokemon-card__info--attack-title">
                        <p>${ability.name}</p>
                        <div>
                          <p>${ability.type}</p>
                        </div>
                      </div>
                      <p class="pokemon-card__info--attack-text">${ability.text}</p>
                    </div>
                  `;
                  })
                  .join("")}
              </div>
              `
                  : ""
              }

              <!-- Btn to rotate -->
              <button class="pokemon-card__btn-rotate pokemon-card__rotate-to-back">
                <span>Flip it</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"></path></svg> 
              </button>
            </div>
          </div>

          <div class="pokemon-card__legalities-container pokemon-card__legalities-container--rotate">
            <!-- Supertype -->
            <p role="h4">
              <span class="sub-title">&mdash; Card subtypes</span>
              ${card.subtypes.join(", ")}
            </p>
            ${
              card?.weaknesses
                ? `
            <!-- Weaknesses -->
            <p role="h4">
              <span class="sub-title">&mdash; Card weaknesses</span>
              ${card.weaknesses
                .map((weakness) => {
                  return `
                  <span class="pokemon-card__text-image">
                    <span>${weakness.type} ${weakness.value}</span>
                    <span class="pokemon-card__text-image--img-container">
                      <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${weakness.type.toLowerCase()}.png?v=1718968515" alt="${
                    weakness.type
                  } symbol" />
                    </span>
                  </span>
                `;
                })
                .join("")}
            </p>`
                : ""
            }

            ${
              card.retreatCost
                ? `<!-- Retreat cost -->
            <p role="h4">
              <span class="sub-title">&mdash; Card retreat cost</span>
              <span class="pokemon-card__text-image">
                <span>${
                  card.retreatCost.every(
                    (cost) => cost === card.retreatCost.at(0)
                  )
                    ? card.retreatCost.at(0)
                    : card.retreatCost.join(", ")
                }</span>
                <span class="pokemon-card__text-image--img-container">
                  ${card.retreatCost
                    .map((cost) => {
                      return `
                      <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${cost.toLowerCase()}.png?v=1718968515" alt="${cost} symbol" />  
                    `;
                    })
                    .join("")}
                </span>
              </span>
            </p>`
                : ""
            }
            <!-- Evolves from -->
            ${
              card?.evolvesFrom
                ? `
              <p role="h4">
                <span class="sub-title">&mdash; Card evolves from</span>
                ${card.evolvesFrom}
              </p>
              `
                : ""
            }
            <!-- Flavor text -->
            ${
              card?.flavorText
                ? `
              <p role="h4">
                <span class="sub-title">&mdash; Card flavor text</span>
                ${card.flavorText}
              </p>
              `
                : ""
            }
            <!-- Legalities -->
            <p class="pokemon-card__legalities--title">&mdash; Legalities</p>
            <div class="pokemon-card__legalities">
              <div class="pokemon-card__legalities-box">
                ${Object.entries(card.legalities)
                  .map((legality) => {
                    const [key, value] = legality;
                    return `
                    <p>
                    <span class="${value
                      .replace("_", "-")
                      .toLowerCase()}">${value.replace("_", "-")}</span>
                    ${key}
                    </p>
                  `;
                  })
                  .join("")}
              </div>
            </div>

            <!-- Btn to rotate -->
              <button class="pokemon-card__btn-rotate pokemon-card__rotate-to-front">
                <span>Flip it</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"></path></svg> 
              </button>
          </div>
        </div>

        <div class="pokemon-card__prints pokemon-card__mobile-view">
          <div class="pokemon-card__set">
            <div class="pokemon-card__set-series">
              <!-- Set series -->
              <p role="h4">
                <span class="sub-title">&mdash; Release series</span>
                ${card.set.series}
              </p>
              <!-- Set series image -->
              <img src="${card.set.images.logo}" alt="${
    card.set.series
  } logo" loading="lazy" />
            </div>
            <div class='pokemon-card__set-info' data-set='${card.set.id}'>
              <!-- Set name (set) -->
              <p role="h4">
                <span class="sub-title">&mdash; Release name</span>
                ${card.set.name} ${
    card.set.ptcgoCode ? `(${card.set.ptcgoCode})` : ""
  }
              </p>
              <!-- #collection_number / rarity / lang / finishes -->
              <p>#${card.number} &middot; ${card.rarity} ${
    card.regulationMark ? `&middot; ${card.regulationMark}` : ""
  }</p>
            </div>
          </div>

          <div class="pokemon-card__info">
            <!-- Name -->
            <p role="h4">
              <span class="sub-title">&mdash; Card name</span>
                ${card.name}
            </p>
            <!-- Supertype -->
            <p role="h4">
              <span class="sub-title">&mdash; Card supertype</span>
              ${card.supertype}
            </p>
            <!-- Artist -->
            <p role="h4">
              <span class="sub-title">&mdash; Illustrated by</span>
              <span class="pokemon-card__link pokemon-card__artist">${
                card.artist
              }</span>
            </p>

            ${
              card.hp
                ? `<!-- HP -->
            <p role="h4">
              <span class="sub-title">&mdash; Card hp</span>
              <span class="pokemon-card__info--hp">
                <span class="pokemon-card__info--hp-text">
                  <span>HP</span>
                  <span>${card.hp}</span>
                </span>
                ${
                  card.types
                    ? `<img class="pokemon-card__info--hp-symbol" src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${card.types
                        .at(0)
                        .toLowerCase()}.png?v=1718968515" alt="${card.types.at(
                        0
                      )} symbol" />`
                    : ""
                }
              </span>
            </p>`
                : ""
            }

            ${
              card.attacks
                ? `<!-- Attacks -->
            <div class="pokemon-card__info--attacks ${
              card?.abilities ? "pokemon-card__border-btm" : ""
            }">
              <p class="sub-title last">&mdash; Card attacks</p>
              ${card.attacks
                .map((attack) => {
                  return `
                    <div class="pokemon-card__info--attack">
                      <div class="pokemon-card__info--attack-title">
                        <p>${attack.name}</p>
                        <div>
                          <p>${attack.damage}</p>
                          ${attack.cost
                            .map((cost) => {
                              if (cost !== "Free")
                                return `
                                <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${cost.toLowerCase()}.png?v=1718968515" alt="${cost} symbol" />
                            `;
                            })
                            .join("")}
                        </div>
                      </div>
                      <p class="pokemon-card__info--attack-text">${
                        attack.text
                      }</p>
                    </div>
                  `;
                })
                .join("")}
            </div>`
                : ""
            }
            ${
              card?.abilities
                ? `<!-- Abilities -->
            <div class="pokemon-card__info--attacks">
              <p class="sub-title last">&mdash; Card abilities</p>
              ${card.abilities
                .map((ability) => {
                  return `
                  <div class="pokemon-card__info--attack">
                    <div class="pokemon-card__info--attack-title">
                      <p>${ability.name}</p>
                      <div>
                        <p>${ability.type}</p>
                      </div>
                    </div>
                    <p class="pokemon-card__info--attack-text">${ability.text}</p>
                  </div>
                `;
                })
                .join("")}
            </div>
            `
                : ""
            }
          </div>
        </div>

        <div class="pokemon-card__legalities-container pokemon-card__mobile-view">
          <!-- Supertype -->
          <p role="h4">
            <span class="sub-title">&mdash; Card subtypes</span>
            ${card.subtypes.join(", ")}
          </p>
          ${
            card?.weaknesses
              ? `
          <!-- Weaknesses -->
          <p role="h4">
            <span class="sub-title">&mdash; Card weaknesses</span>
            ${card.weaknesses
              .map((weakness) => {
                return `
                <span class="pokemon-card__text-image">
                  <span>${weakness.type} ${weakness.value}</span>
                  <span class="pokemon-card__text-image--img-container">
                    <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${weakness.type.toLowerCase()}.png?v=1718968515" alt="${
                  weakness.type
                } symbol" />
                  </span>
                </span>
              `;
              })
              .join("")}
          </p>`
              : ""
          }

          ${
            card.retreatCost
              ? `<!-- Retreat cost -->
          <p role="h4">
            <span class="sub-title">&mdash; Card retreat cost</span>
            
            <span class="pokemon-card__text-image">
              <span>${
                card.retreatCost.every(
                  (cost) => cost === card.retreatCost.at(0)
                )
                  ? card.retreatCost.at(0)
                  : card.retreatCost.join(", ")
              }</span>
              <span class="pokemon-card__text-image--img-container">
              ${card.retreatCost
                .map((cost) => {
                  return `
                  <img src="https://cdn.shopify.com/s/files/1/0568/7915/3315/files/${cost.toLowerCase()}.png?v=1718968515" alt="${cost} symbol" />  
                `;
                })
                .join("")}
              </span>
            </span>
          </p>`
              : ""
          }
          
           ${
             card?.evolvesFrom
               ? `
                <!-- Evolves from -->
                <p role="h4">
                  <span class="sub-title">&mdash; Card evolves from</span>
                  ${card.evolvesFrom}
                </p>
              `
               : ""
           }

           ${
             card?.flavorText
               ? `
                <!-- Flavor text -->
                <p role="h4">
                  <span class="sub-title">&mdash; Card flavor text</span>
                  ${card.flavorText}
                </p>
            `
               : ""
           }
          
          <!-- Legalities -->
          <p class="pokemon-card__legalities--title">&mdash; Legalities</p>
          <div class="pokemon-card__legalities">
            <div class="pokemon-card__legalities-box">
              ${Object.entries(card.legalities)
                .map((legality) => {
                  const [key, value] = legality;
                  return `
                  <p>
                  <span class="${value
                    .replace("_", "-")
                    .toLowerCase()}">${value.replace("_", "-")}</span>
                  ${key}
                  </p>
                `;
                })
                .join("")}
            </div>
          </div>
        </div>
      </div>
  `;

  contentContainer.insertAdjacentHTML("beforeend", markup);

  // Render products
  renderRelatedProducts(card.name, card.artist);

  // Scroll to the card TOP
  const targetPosition =
    contentContainer.getBoundingClientRect().top + window.scrollY - 150; // Adjust -50 to the desired margin
  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
};

// const renderSets = function (sets) {
//   // Cleaning the UI
//   cleanUI();

//   sessionStorage.setItem("all-sets", JSON.stringify(sets));

//   const markup = `
//     <div class="sets">
//       <div role="table">
//         <div role="thead">
//           <div role="tr">
//             <p role="th">Name</p>
//             <p role="th">Cards</p>
//             <p role="th">Date</p>
//           </div>
//         </div>
//         <div role="tbody">
//           ${sets
//             .map(
//               (set) => `
//             <div role="tr" class="sets__set-container" data-set="${set.code}">
//               <p role="td" class="sets__set-name-container">
//                 <span class="sets__set-svg">
//                   <!-- <object
//                     type="image/svg+xml"
//                     data="${set.icon_svg_uri}"
//                   >
//                     Your browser does not support SVG
//                   </object> -->
//                   <img src="${set.icon_svg_uri}" alt="Icon of ${set.name}" />
//                 </span>
//                 <span class="sets__set-name">${set.name}</span>
//                 <span class="sets__set-code">${set.code.toUpperCase()}</span>
//               </p>
//               <p role="td">${set.card_count}</p>
//               <p role="td">${set.released_at}</p>
//             </div>
//           `
//             )
//             .join("")}
//         </div>
//       </div>
//     </div>
//   `;

//   contentContainer.insertAdjacentHTML("beforeend", markup);
// };

const renderRelatedProductsButtons = function (cardName, artistName) {
  const container = contentContainer.querySelector(
    ".pokemon__related-products--btns-container"
  );

  const buttonsMarkup = `
    <button class="pokemon__related-products--card" data-card="${cardName}">Show products related to this card</button>
    <!-- <button class="pokemon__related-products--artist" data-artist="${artistName}">Show products related to this artist</button> -->
  `;

  container.innerHTML = buttonsMarkup;
};

// const fetchingRelatedProducts = async function (cardName, artistName) {
//   const loadingMarkup = `
//     <div class="loading-spinner">
//       <span></span>
//     </div>
//   `;

//   const buttonsMarkup = `
//     <button class="magic__related-products--card" data-card="${cardName}">Show products related to this card</button>
//     <button class="magic__related-products--artist" data-artist="${artistName}">Show products related to this artist</button>
//   `;

//   const container = contentContainer.querySelector(
//     ".magic__related-products--btns-container"
//   );

//   try {
//     // In case we will not fetch the products every single time we select the card
//     if (products.length) return products;

//     // Render loading spinner
//     container.innerHTML = loadingMarkup;

//     // Fetch related products
//     const res = await fetch("https://upi-euro.onrender.com/api/products");
//     // const res = await fetch('http://localhost:3000/api/products');
//     if (!res.ok)
//       throw new Error(
//         "An error occurred while fetching related products to this card"
//       );

//     const data = await res.json();
//     products = data;

//     // Render buttons
//     container.innerHTML = buttonsMarkup;
//   } catch (error) {
//     console.log(error.message);
//     container.innerHTML = error.message;
//   }
// };

const fetchingCards = async function (cardName) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    // Creating the query for fetch request
    let query = "";
    const checkedOptions = allOptions.filter((option) => option.checked);

    // Guard close
    if (
      advancedBtn.classList.contains("search__advanced-active") &&
      !checkedOptions.length &&
      !cardName
    )
      throw new Error(
        "Kindly refine your search criteria or review the advanced search settings for better results."
      );

    // Adjust the query if there's a search input value
    if (cardName) query = `name:"${cardName}"`;

    // Adjusting the query if there're some advanced search options selected
    // 1. check if the advanced search button is selected and checked options are > 0
    if (
      advancedBtn.classList.contains("search__advanced-active") &&
      checkedOptions.length
    ) {
      // 2. get the checked options for energy type and attacks type
      const checkedEnergyType = energyTypeOptions.filter(
        (option) => option.checked
      );
      const checkedAttacksType = attacksTypeOptions.filter(
        (option) => option.checked
      );

      // 3. check if the energy type options are selected
      if (checkedEnergyType.length) {
        const values = checkedEnergyType.map(
          (option) => `types:${option.value}`
        );
        query = `${query} (${values.join(" OR ")})`;
      }

      // 4. check if the attacks type options are selected
      if (checkedAttacksType.length) {
        const values = checkedAttacksType.map(
          (option) => `attacks.cost:${option.value}`
        );
        query = `${query} (${values.join(" OR ")})`;
      }
    }

    const res = await fetch(`${API}/cards?q=${query.trim()}&page=1`);
    if (!res.ok) throw new Error("Card not found. Please try again!");

    let data = await res.json(); // data it's an array containing card data
    // const data = { totalCount: 0, data: [] };

    // 5. Scroll the users down to see the loading and the cards
    const targetPosition =
      contentContainer.getBoundingClientRect().top + window.scrollY - 85; // Adjust -50 to the desired margin
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });

    if (data) {
      if (data.totalCount > 250) {
        // render cards to UI -- GOOD FOR UX
        renderCards(data, "fetching");

        // 1. Get the total pages
        const count = data.totalCount / 250;
        let pages = count % 2 === 0 ? count : Math.floor(count) + 1;

        const requests = Array.from({ length: pages }, (_, i) =>
          fetch(`${API}/cards?q=${query.trim()}&page=${i + 1}`)
        );

        // 2. Fetch all the missing cards
        const res = await Promise.all(requests);
        const newData = await Promise.all(res.map((r) => r.json()));
        const newCards = newData.flatMap((d) => d.data);
        data.data = [...data.data, ...newCards];

        if (sessionStorage.getItem("cardClicked") !== "true") {
          // Render them to the UI
          renderCards(data);
        }
      } else {
        // render cards to UI -- GOOD FOR UX
        renderCards(data);
      }
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();

    // Print the error message to the UI
    const markup = `
      <p style="text-align: center;">${error.message}</p>
    `;

    contentContainer.insertAdjacentHTML("beforeend", markup);
  }
};

const fetchCard = async function (cardId) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards/${cardId}`);
    if (!res.ok) throw new Error("Card not found. Please try again!");

    let { data } = await res.json(); // data it's an array containing card data
    // const data = { totalCount: 0, data: [] };

    if (data) {
      renderCard(data);
      return data;
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();

    // Print the error message to the UI
    const markup = `
      <p style="text-align: center;">${error.message}</p>
    `;

    contentContainer.insertAdjacentHTML("beforeend", markup);
  }
};

// const fetchingSets = async function () {
//   try {
//     // Render Loading Spinner
//     renderLoadingSpinner();

//     const res = await fetch(`${API}/sets`);
//     if (!res.ok) throw new Error("Card not found. Please try again!");

//     const { data } = await res.json();

//     if (data) {
//       // Avoid page block because of this heavy data
//       // localStorage.setItem('all-sets', JSON.stringify(data));
//       // render cards to UI
//       renderSets(data);
//     }
//   } catch (error) {
//     console.log(error.message);

//     // Cleaning the UI
//     cleanUI();
//   }
// };

const fetchingSetCards = async function (setId) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards?q=set.id:${setId}`);
    if (!res.ok) throw new Error("Set Cards not found. Please try again!");

    const data = await res.json(); // data it's an array containing card data

    if (data) {
      if (data.totalCount > 250) {
        // render cards to UI -- GOOD FOR UX
        renderCards(data, "fetching");

        // 1. Get the total pages
        const count = data.totalCount / 250;
        let pages = count % 2 === 0 ? count : Math.floor(count) + 1;

        const requests = Array.from({ length: pages }, (_, i) =>
          fetch(`${API}/cards?q=set.id:${setId}&page=${i + 1}`)
        );

        // 2. Fetch all the missing cards
        const res = await Promise.all(requests);
        const newData = await Promise.all(res.map((r) => r.json()));
        const newCards = newData.flatMap((d) => d.data);
        data.data = [...data.data, ...newCards];

        if (sessionStorage.getItem("cardClicked") !== "true") {
          // Render them to the UI
          renderCards(data);
        }
      } else {
        // render cards to UI -- GOOD FOR UX
        renderCards(data);
      }
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();
  }
};

const fetchingArtistCards = async function (artist) {
  try {
    // Render Loading Spinner
    renderLoadingSpinner();

    const res = await fetch(`${API}/cards?q=artist:"${artist}"`);
    if (!res.ok) throw new Error("Artist Cards not found. Please try again!");

    const data = await res.json(); // data it's an array containing card data

    if (data) {
      if (data.totalCount > 250) {
        // render cards to UI -- GOOD FOR UX
        renderCards(data, "fetching");

        // 1. Get the total pages
        const count = data.totalCount / 250;
        let pages = count % 2 === 0 ? count : Math.floor(count) + 1;

        const requests = Array.from({ length: pages }, (_, i) =>
          fetch(`${API}/cards?q=artist:"${artist}"&page=${i + 1}`)
        );

        // 2. Fetch all the missing cards
        const res = await Promise.all(requests);
        const newData = await Promise.all(res.map((r) => r.json()));
        const newCards = newData.flatMap((d) => d.data);
        data.data = [...newCards];

        if (sessionStorage.getItem("cardClicked") !== "true") {
          // Render them to the UI
          renderCards(data);
        }
      } else {
        // render cards to UI -- GOOD FOR UX
        renderCards(data);
      }
    }
  } catch (error) {
    console.log(error.message);

    // Cleaning the UI
    cleanUI();

    // Print the error message to the UI
    const markup = `
      <p style="text-align: center;">${error.message}</p>
    `;

    contentContainer.insertAdjacentHTML("beforeend", markup);
  }
};

// const fetchingSetInfo = async function (setId) {
//   try {
//     const res = await fetch(`${API}/sets/${setId}`);
//     const data = await res.json();
//     return data;
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// const fetchingSymbols = async function () {
//   try {
//     const res = await fetch(`${API}/symbology`);
//     if (!res.ok) throw new Error(res.status);

//     const { data } = await res.json();
//     localStorage.setItem("symbols", JSON.stringify(data));
//   } catch (error) {
//     console.log(error.message);
//   }
// };
// localStorage.getItem("symbols") || fetchingSymbols();

// --- Event handlers --- //
// Searching for cards event
searchForm.addEventListener("submit", function (e) {
  e.preventDefault();

  // Searching...
  let correctedValue;
  const searchType = sessionStorage.getItem("search type");

  // In cas the user didn't enter any value
  if (
    (!searchInput.value && searchType === "artist") ||
    (searchType === "card" &&
      !searchInput.value &&
      !advancedBtn.classList.contains("search__advanced-active"))
  )
    return;

  // Adjusting the searched input value
  correctedValue = searchInput.value.toLowerCase();

  // search by card
  if (searchType === "card") fetchingCards(correctedValue);
  // search by artist
  else if (searchType === "artist") fetchingArtistCards(correctedValue);
});

// Selecting card event
contentContainer.addEventListener("click", async function (e) {
  // 1. selecting DOM elements
  const cardsEl = contentContainer.querySelector(".cards");
  if (!cardsEl || !e.target.closest(".cards__img")) return;

  // 2. Storing click on card
  sessionStorage.setItem("cardClicked", true);

  // const cards = JSON.parse(sessionStorage.getItem("cards"));
  // const card = cards.find((card) => card.id === e.target.dataset.cardId); // We are storing the card id on the image

  // 2. fetching the card set info
  // const setInfo = await fetchingSetInfo(card.set_id);

  // 3. render the card
  const card = await fetchCard(e.target.dataset.cardId);

  // 4. fetch related products
  // await fetchingRelatedProducts(card.name, card.artist);
  renderRelatedProductsButtons(card.name, card.artist);

  // 5. Handle click related buttons
  sessionStorage.setItem("related-type", "none");
});

// Handle click on the card set
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".pokemon-card__set")) return;

  const setId = e.target
    .closest(".pokemon-card__set")
    .querySelector(".pokemon-card__set-info").dataset.set;
  fetchingSetCards(setId);
});

// Handle click on the card artist
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".pokemon-card__artist")) return;

  const artist = e.target.textContent.trim();
  fetchingArtistCards(artist);
});

// Handle click on all sets buttons
// allSetsBtn.addEventListener("click", function () {
//   // Clean the input
//   searchInput.value = "";

//   // 1. hide and disable the advanced the advanced search
//   advancedBtn.disabled = true;
//   toggleSearchAdanvaced("hide");

//   // 2. disable all the filters
//   unselectAllAdvancedSearchFilters();

//   // Avoid page block because of this heavy data
//   sessionStorage.getItem("all-sets")
//     ? renderSets(JSON.parse(sessionStorage.getItem("all-sets")))
//     : fetchingSets();
//   // fetchingSets();
// });

// Handle click on the advanced search button
advancedBtn.addEventListener("click", function () {
  // Show
  if (!this.classList.contains("search__advanced-active"))
    toggleSearchAdanvaced("show");
  // Hide
  else if (this.classList.contains("search__advanced-active")) {
    // 1. hide the advanced search
    toggleSearchAdanvaced("hide");

    // 2. disable all the filters
    unselectAllAdvancedSearchFilters();
  }
});

// Handle click on the close advanced search container button
closeAdvancedSearchBtn.addEventListener("click", function () {
  // 1. hide the advanced search
  toggleSearchAdanvaced("hide");

  // 2. disable all the filters
  unselectAllAdvancedSearchFilters();
});

// Handle on the advanced search options (individual option)
allOptions.forEach((option, i) => {
  option.addEventListener("change", function () {
    if (this.checked) {
      // highlight the label
      toggleSearchOption("active", i);
    } else {
      // disable the label
      toggleSearchOption("disable", i);
    }
  });
});

// Handle click on set box
// contentContainer.addEventListener("click", function (e) {
//   if (!e.target.closest(".sets__set-container")) return;

//   const setCode = e.target.closest(".sets__set-container").dataset.set;
//   fetchingSetCards(setCode);
// });

// Handle click on artist button
searchByArtistBtn.addEventListener("click", function () {
  updateInput("artist");

  // 1. hide and disable the advanced the advanced search
  advancedBtn.style.display = "none";
  toggleSearchAdanvaced("hide");

  // 2. disable all the filters
  unselectAllAdvancedSearchFilters();
});

// Handle click on card button
searchByCardBtn.addEventListener("click", function () {
  updateInput("card");

  // 1. unable the advanced search feature
  advancedBtn.style.display = "inline-block";
});

// Handle click on show related products by card name
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".pokemon__related-products--card")) return;

  // 1. Selecting the btn element
  const target = e.target.closest(".pokemon__related-products--card");
  const container = contentContainer.querySelector(
    ".pokemon__related-products--container"
  );

  // 2. Changing the value of the related click type
  sessionStorage.setItem("related-type", "card");

  // 2. Clean the container
  container.innerHTML = "";

  // 3. Render related products
  // const artistName = target.nextElementSibling.dataset.artist;
  // renderRelatedProductByCardName(
  //   target.dataset.card,
  //   artistName,
  //   searchInput.value !== "" ? true : false
  // );
  renderRelatedProductByCardName(
    target.dataset.card,
    "",
    searchInput.value !== "" ? true : false
  );
});

// Handle click on show related products by artist name
// contentContainer.addEventListener("click", function (e) {
//   if (!e.target.closest(".magic__related-products--artist")) return;

//   // 1. Selecting the btn element
//   const target = e.target.closest(".magic__related-products--artist");
//   const container = contentContainer.querySelector(
//     ".magic__related-products--container"
//   );

//   // 2. Changing the value of the related click type
//   sessionStorage.setItem("related-type", "artist");

//   // 3. Clean the container
//   container.innerHTML = "";

//   // 4. Render related products
//   const cardName = target.previousElementSibling.dataset.card;
//   renderRelatedProductByArtistName(cardName, target.dataset.artist);
// });

// Handle click on rotate magic card (FLIP IT)
contentContainer.addEventListener("click", function (e) {
  if (!e.target.closest(".pokemon-card__btn-rotate")) return;

  const container = contentContainer.querySelector(
    ".pokemon-card__container--rotate"
  );

  // 1. Selecting the btn element
  const target = e.target.closest(".pokemon-card__btn-rotate");

  // 2. Check if the card is flipped
  if (target.classList.contains("pokemon-card__rotate-to-front")) {
    // Remove the flipped class
    container.classList.remove("pokemon-card__rotated");
  } else {
    // Add the flipped class
    container.classList.add("pokemon-card__rotated");
  }
});

// Handlle click on scroll to up button
btnScrollUp.addEventListener("click", function () {
  if (this.classList.contains("button-scroll-up--hidden")) return;

  console.log("Click!");

  const targetPosition =
    contentContainer.getBoundingClientRect().top + window.scrollY - 85; // Adjust -50 to the desired margin
  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
});
